import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { CodelistTranslationService } from './codelist-translation.service';
import { FormatMatchResult } from '../interfaces/format-match-result.interface';

export interface Attachment {
  content: Uint8Array;
  filename: string;
}

export interface EInvoiceViewerDocumentPayload {
  model: any;
  format?: FormatMatchResult;
  additionalAttachments?: Attachment[];
  rawXml?: string;
  xmlFileName?: string;
  pdfBytes?: Uint8Array;
}

export type EInvoiceValidationStatus = 'idle' | 'validating' | 'valid' | 'invalid' | 'error';

export interface EInvoiceValidationState {
  status: EInvoiceValidationStatus;
  message?: string;
  errorCount?: number;
  warningCount?: number;
}

@Injectable({
  providedIn: 'root',
})
export class EInvoiceViewerService {
  public filesAdded$: Subject<File[]> = new Subject<File[]>();
  public dragChanged$: Subject<boolean> = new Subject<boolean>();
  public uploadClicked$: Subject<void> = new Subject<void>();
  public document$: BehaviorSubject<EInvoiceViewerDocumentPayload | undefined> = new BehaviorSubject<EInvoiceViewerDocumentPayload | undefined>(undefined);
  public processing$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public validationState$: BehaviorSubject<EInvoiceValidationState> = new BehaviorSubject<EInvoiceValidationState>({ status: 'idle' });
  public validationRequested$: Subject<void> = new Subject<void>();
  public validationDetailsRequested$: Subject<void> = new Subject<void>();
  public onError$: Subject<{ message: string, title?: string }> = new Subject<{ message: string, title?: string }>();

  constructor(
    private codeListService: CodelistTranslationService
  ) {

  }

  public filesAdded(files: File[]): void {
    this.filesAdded$.next(files);
  }
  public dragOver(): void {
    this.dragChanged$.next(true);
  }
  public dragLeave(): void {
    this.dragChanged$.next(false);
  }
  public uploadClicked(): void {
    this.uploadClicked$.next();
  }
  public setDocument(document: any, format?: FormatMatchResult, additionalAttachments?: Attachment[], rawXml?: string, xmlFileName?: string, pdfBytes?: Uint8Array): void {
    this.document$.next({ model: document, format: format, additionalAttachments: additionalAttachments, rawXml, xmlFileName, pdfBytes });
  }
  public setProcessing(processing: boolean): void {
    this.processing$.next(processing);
  }
  public setValidationState(state: EInvoiceValidationState): void {
    this.validationState$.next(state);
  }
  public requestValidation(): void {
    this.validationRequested$.next();
  }
  public requestValidationDetails(): void {
    this.validationDetailsRequested$.next();
  }
  public loadCodelists(locale: string): void {
    this.codeListService.loadCodelistTranslations(locale);
  }
  public error(error: { message: string, title?: string }): void {
    this.onError$.next(error);
  }

}
